import { useState } from "react";
import { api, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { Wand2, Sparkles, X } from "lucide-react";

/* Ajuda da IA para escrever o comunicado: a partir de notas rápidas, ou melhorar o texto já escrito. */
export default function CommuniqueAiHelper({ form, setForm }) {
  const [open, setOpen] = useState(false);
  const [notes, setNotes] = useState("");
  const [busy, setBusy] = useState(null);

  const run = async (mode) => {
    setBusy(mode);
    try {
      const r = await api.post("/communiques/draft", {
        mode, subject: form.subject || null, notes: mode === "write" ? notes : form.message,
      });
      setForm((f) => ({ ...f, subject: f.subject.trim() ? f.subject : r.data.subject, message: r.data.message, variants: null }));
      toast.success(mode === "write" ? "Texto escrito — revê e ajusta à vontade" : "Texto melhorado");
      setOpen(false);
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(null);
  };

  return (
    <div className="space-y-3" data-testid="communique-ai-helper">
      <div className="flex flex-wrap gap-2">
        <button onClick={() => setOpen(!open)} disabled={!!busy}
          className="kw-btn-secondary !py-2 text-[10px] inline-flex items-center gap-1.5" data-testid="communique-ai-write-open">
          <Wand2 className="w-3 h-3" /> Escrever com IA
        </button>
        <button onClick={() => run("improve")} disabled={!!busy || form.message.trim().length < 5}
          className="kw-btn-secondary !py-2 text-[10px] inline-flex items-center gap-1.5" data-testid="communique-ai-improve">
          <Sparkles className="w-3 h-3" /> {busy === "improve" ? "A melhorar…" : "Melhorar o texto"}
        </button>
      </div>
      {open && (
        <div className="border border-[#E50000]/40 bg-[#E50000]/5 p-4 space-y-3" data-testid="communique-ai-panel">
          <div className="flex items-center gap-2">
            <div className="kw-overline text-[#E50000] flex-1">Diz à IA o que queres comunicar</div>
            <button onClick={() => setOpen(false)} className="text-[#737373] hover:text-white"><X className="w-4 h-4" /></button>
          </div>
          <textarea className="kw-input min-h-[100px]" value={notes} onChange={(e) => setNotes(e.target.value)}
            placeholder="Ex.: enviar a apresentação da Sessão 0; pedir que revejam antes de quinta; lembrar o reporting até domingo 23:59"
            data-testid="communique-ai-notes" />
          <button onClick={() => run("write")} disabled={!!busy || notes.trim().length < 5}
            className="kw-btn-primary !py-2 text-[10px] inline-flex items-center gap-1.5" data-testid="communique-ai-write">
            <Wand2 className="w-3 h-3" /> {busy === "write" ? "A escrever…" : "Escrever"}
          </button>
          <p className="text-[10px] text-[#737373]">Substitui a mensagem atual. Depois podes adaptar a cada perfil e pré-visualizar.</p>
        </div>
      )}
    </div>
  );
}
